import StructFunctionality, { forget } from "./StructFunctionality";
const item = 'prodotti';

export default function ProductStruct ( products )
{ return StructFunctionality( {}, products, item ); }

export function forget_products (  )
{ forget( item ); }
